import { render, staticRenderFns } from "./SendMessageTargetsInput.vue?vue&type=template&id=5ebab96a&scoped=true&lang=pug"
import script from "./SendMessageTargetsInput.vue?vue&type=script&lang=ts"
export * from "./SendMessageTargetsInput.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageTargetsInput.vue?vue&type=style&index=0&id=5ebab96a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebab96a",
  null
  
)

export default component.exports